var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4746 0H8.5C4.10635 0 0.5 3.60635 0.5 8.0254V24C0.5 28.3937 4.10635 32 8.5 32H24.4746C28.8937 32 32.5 28.3937 32.5 23.9746V8.0254C32.5 3.60635 28.8937 0 24.4746 0ZM20.7921 16H17.7698V25.9048H13.9603V16H11.9286V11.9365H13.7064V10.2095C13.7064 8.58413 14.519 6.01905 17.9476 6.01905H21.0714V9.39683H18.8619C18.5064 9.39683 18.0238 9.6254 18.0238 10.4127V11.9365H21.1476L20.7921 16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookSocial);
export default __webpack_public_path__ + "static/media/facebook-social.103aa4b896031481fc5e428a2da79292.svg";
export { ForwardRef as ReactComponent };